import { UnitOfMeasureEnum } from "../../../api/Representation";
import { MarketplaceProductSaleTypeEnum } from "../../marketplace/api/Representation";
export var StockAdjustmentTypeEnum;
(function (StockAdjustmentTypeEnum) {
    StockAdjustmentTypeEnum["INCREASE"] = "INCREASE";
    StockAdjustmentTypeEnum["DECREASE"] = "DECREASE";
    StockAdjustmentTypeEnum["SET_AVAILABLE"] = "SET_AVAILABLE";
})(StockAdjustmentTypeEnum || (StockAdjustmentTypeEnum = {}));
export var StockAdjustmentSourceEnum;
(function (StockAdjustmentSourceEnum) {
    StockAdjustmentSourceEnum["MANUAL"] = "MANUAL";
    StockAdjustmentSourceEnum["CONSIGNMENT"] = "CONSIGNMENT";
})(StockAdjustmentSourceEnum || (StockAdjustmentSourceEnum = {}));
export var DayOfWeekEnum;
(function (DayOfWeekEnum) {
    DayOfWeekEnum["MONDAY"] = "MONDAY";
    DayOfWeekEnum["TUESDAY"] = "TUESDAY";
    DayOfWeekEnum["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeekEnum["THURSDAY"] = "THURSDAY";
    DayOfWeekEnum["FRIDAY"] = "FRIDAY";
    DayOfWeekEnum["SATURDAY"] = "SATURDAY";
    DayOfWeekEnum["SUNDAY"] = "SUNDAY";
})(DayOfWeekEnum || (DayOfWeekEnum = {}));
